import { Permiso } from './../../../../_entities/Enums/permiso.enum';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MarcaDispositivoService } from './../../services/marca-dispositivo.service';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';


@Component({
  selector: 'kt-marca-dispositivo',
  templateUrl: './marca-dispositivo.component.html',
  styleUrls: ['./marca-dispositivo.component.scss']
})
export class MarcaDispositivoComponent implements OnInit {
  public marcaRegistros: any[];

  public showFilterRow: boolean;
  public showHeaderFilter: boolean;
  public showNavigationButtons: boolean;
  public showPageSizeSelector: boolean;

  public permisoConsultarMarcasDispositivos: string;
  public permisoAgregarMarcaDispositivo: string;
  public permisoActualizarMarcaDispositivo: string;
  public permisoEliminarMarcaDispositivo: string;

  public currentFilter: any;

  constructor(
    private marcaDispositivoService: MarcaDispositivoService,
    private toastService: ToastrService,
    private router: Router) { 
      this.showFilterRow = true;
      this.showHeaderFilter = true;
      this.showNavigationButtons = true;
      this.showPageSizeSelector = true;
    }

  ngOnInit() {
    this.obtenerPermisos();
    this.obtenerMarcas();
  }

  obtenerMarcas() {
    this.marcaDispositivoService.obtenerMarcas().subscribe(
      (res) => {
        this.marcaRegistros = res;
      }, (err) => {
        this.toastService.error('ocurrio un error al obtener los sims');
    });
  }

  altaMarcaDispositivo() {
    this.router.navigateByUrl('/home/administracion/dispositivos/marca/alta');
  }

  editarMarca(idMarca) {
    this.router.navigateByUrl('/home/administracion/dispositivos/marca/editar/' + idMarca);
  }

  eliminarMarca(data) {
    Swal.fire({
      title: 'Eliminar',
      text: `¿Está seguro que desea eliminar la marca ` + data.nombre,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.value) {
        this.marcaDispositivoService.eliminarMarca(data.id).subscribe(res => {
          Swal.fire(
            'Eliminado!',
            'La marca ha sido eliminada.',
            'success'
          );
          this.ngOnInit();
        }, err => {
          Swal.fire(
            'Ops!',
            'Error al intentar eliminar la marca del dispositivo.',
            'error'
          );
        });
      }
    })
  }

  /**Obtener Permisos para marca dispositivos */
  public get Permiso() {
    return Permiso;
  }

  obtenerPermisos(){
    this.permisoConsultarMarcasDispositivos = Permiso.ConsultarMarcasDispositivos;
    this.permisoAgregarMarcaDispositivo = Permiso.AgregarMarcaDispositivo;
    this.permisoActualizarMarcaDispositivo = Permiso.ActualizarMarcaDispositivo;
    this.permisoEliminarMarcaDispositivo = Permiso.EliminarMarcaDispositivo;
  }

}
